import { RadioButton as StyledRadioButton, Label, Container } from './styles';
import { BaseRadioButtonProps } from './types';

const BaseRadioButton = (props: BaseRadioButtonProps) => {
  return (
    <Container>
      <StyledRadioButton type='radio' {...props} />
    </Container>
  );
};

BaseRadioButton.Label = Label;
export default BaseRadioButton;
